<template>
  <div class="product">
    <div class="index-image">
      <div class="inner-text">
        <p class="title">About Us</p>
        <p class="content">We are able to serve billions of users in the aspects of big data, artificial intelligence and basic service, provide systematic full-link solutions for business customers, and help companies seek practical innovation and realize sustainable and fast business growth.</p>
      </div>
    </div>
    <div class="index-next-content">
      <div class="us-content">
        <div class="us-font">
          <p>
          The company has a complete organizational structure which consists of a General Manager Office, an Operation Center, an Administrative Center, a Product Technology Center, an Investment Promotion Center, and a Research and Development Center, each of which has multiple subordinate divisions.
          </p>
          <p>
          We are a comprehensive Internet digital software technology service provider committed to providing personalized solutions for system customization and development. Our company focuses on the fields of integrated payment, intelligent digital marketing, finance and supply chain. The company's products support online & offline integrated payment, POS payment, cashier payment, collection equipment payment, AI face-scanning payment, and IoT payment. The technical strength of Kucheng is fully reflected in these payment methods. Kucheng Technology adheres to the development philosophy of "making practical efforts at present and looking forward to the future" and obeys the management ideas of "sincerity, openness, innovation, win-win". It strives to become a technology-driven and data-enabled leading Internet software company.
          </p>
        </div>
        <div>
          <img src="../assets/us.jpeg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product',
  data () {
    return {
      aplicationArr: [
        {
          icon: 'el-icon-attract',
          title: '重大危险源监测预警',
          nextTitle: '主要用于监测企业构成重大危险源的危化品储存设施及生产装置实时数据和预警、可燃有毒气体数据及预警、危险工艺安全参数监测预警、监控视频等信息。'
        },
        {
          icon: 'el-icon-mobile',
          title: '重大危险源监测预警',
          nextTitle: '主要用于监测企业构成重大危险源的危化品储存设施及生产装置实时数据和预警、可燃有毒气体数据及预警、危险工艺安全参数监测预警、监控视频等信息。'
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.product
  padding-bottom 50px
  .index-image
      height:380px
      background-color: rgba(90, 90, 90, 1);
      background-image: url(../assets/bannerbghsy.jpeg);
      background-repeat: no-repeat;
      background-position: center
     .inner-text
        margin 0 auto
        padding-top 100px
        width 880px
        color #fff
        .title
          font-size 36px
          font-weight 500
        .content
          font-size 14px
          width 500px
          line-height 30px
  .index-next-content
     width 100%
     margin-top 50px
    .us-content
      width: 1100px
      margin 0 auto
      display flex
      &>div
        flex 1
      .us-font
        padding-right 20px
      img
        width 100%
</style>



// WEBPACK FOOTER //
// src/pages/knowUs.vue